import { render, staticRenderFns } from "./PremiumBreakdown.vue?vue&type=template&id=90f651c0"
import script from "./PremiumBreakdown.vue?vue&type=script&lang=js"
export * from "./PremiumBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports